export const PREFIX = 'LANDING_HOME_FAVORITE_REPORT-';
export const GET_REPORT_BY_USER_ID_REQUEST =
  PREFIX + 'GET_REPORT_BY_USER_ID_REQUEST';
export const GET_REPORT_BY_USER_ID_FAILURE =
  PREFIX + 'GET_REPORT_BY_USER_ID_FAILURE';
export const GET_REPORT_BY_USER_ID_SUCCESS =
  PREFIX + 'GET_REPORT_BY_USER_ID_SUCCESS';
export const GET_FAVORITE_REPORT = PREFIX + 'GET_FAVORITE_REPORT';
export const DISMISS_FAVORITE_REPORT = PREFIX + 'DISMISS_FAVORITE_REPORT';
export const UNDISMISS_FAVORITE_REPORT = PREFIX + 'UNDISMISS_FAVORITE_REPORT';

export const SET_CURRENT_SELECTED_MENU = PREFIX + 'SET_CURRENT_SELECTED_MENU';
export const SET_STANDARD_SELECTED_TAGS = PREFIX + 'SET_STANDARD_SELECTED_TAGS';
export const GET_TOP_FAVORITE_REPORTS_REQUEST = PREFIX + 'GET_TOP_FAVORITE_REPORTS_REQUEST';
export const GET_TOP_FAVORITE_REPORTS_FAILURE =  PREFIX + 'GET_TOP_FAVORITE_REPORTS_FAILURE';
export const GET_TOP_FAVORITE_REPORTS_SUCCESS = PREFIX + 'GET_TOP_FAVORITE_REPORTS_SUCCESS';
